export default "__VITE_ASSET__C5VrB0DF__"